import BaseModel from '../core/BaseModel'
export default class ViewUserLevelModel extends BaseModel {
    constructor() {
        super({ 
                name: "view_user_level",
                tableName: 'view_user_level',
                display_key: 'name'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            name: { 
                name: 'name', 
                type: "String", 
                label: 'Cấp bậc',
                filter: { type: 'input', match: 'custom', placeHolder: 'Nhập tên cấp bậc'}
            },
            parentName: { 
                name: 'parentName', 
                type: "String", 
                label: 'Cấp trên',
                filter: { type: 'input', match: 'custom', placeHolder: 'Nhập tên cấp trên'},
                computed: (data) => {
                    data.parentName = (data.parents != undefined && data.parents != null) ? data.parents.name : '';
                }
            },
            // is_management: {
            //     name: 'is_management', label: 'Quản lý dữ liệu cấp dưới', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 15, disabled: true,
            //     options: [{ value: 1, label: 'Có'}, { value: 0, label: 'Không'}],
            //     filter: { type: 'select',  display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
            // },
            status: {
                name: 'status', label: 'Hiển thị sử dụng', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 15, disabled: true,
                options: [{ value: 1, label: 'Có'}, { value: 0, label: 'Không'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            parent_id: {
                refs: 'description level_parent_index parent_id parents { name }',
                display: false
            }
        },)
    }

}